import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Checkbox, Row, Col, Alert } from 'antd';
import { UserOutlined, LockOutlined, LoadingOutlined, GoogleOutlined, FacebookFilled } from '@ant-design/icons';
import { Spin } from 'antd';
import { assets } from '../../assets';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { IAppDispatch, IRootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { userSignIn } from 'src/redux/api/authApi';
import './signIn.scss';
import { IUserData } from 'src/redux/api/authSlice';
import { setSelectedPath } from 'src/redux/navbar';

export interface IUserSignInData {
    email: string;
    password: string;
    remember: boolean;
}

export const SignInPage = () => {
    const dispatch = useDispatch<IAppDispatch>();
    const { loading, error, userData, role, accessToken } = useSelector((state: IRootState) => state.auth);
    const navigate = useNavigate();
    const location = useLocation();
    console.log(role);
    const onSubmit = (data: IUserData) => {
        dispatch(userSignIn(data));
    };

    // Navigate after successful login
    useEffect(() => {
        // Only redirect if user is authenticated (has accessToken and userData)
        // This prevents redirect when user lands on SignIn page after logout
        if (userData && accessToken && role !== 'unknown') {
            const params = new URLSearchParams(location.search);
            const redirectPath = params.get('redirect');

            if (redirectPath === 'checkout') {
                navigate('/checkout');
            } else if (redirectPath) {
                navigate(`/${redirectPath}`);
            } else {
                navigate('/');
            }
        }
    }, [userData, accessToken, role, location.search, navigate]);

    // reload getUserInfo by token

    return (
        <Row gutter={16} className="auth-page-row" style={{ minHeight: '100vh' }}>
            <Col xs={0} sm={0} md={14} lg={14} className="auth-image-col">
                <div className="backgroundSignIn">
                    <img src={assets.signInSignUpBG} alt="" />
                </div>
            </Col>

            <Col xs={24} sm={24} md={10} lg={10} className="auth-form-col" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ width: '90%' }}>
                    <Form
                        name="login"
                        initialValues={{ remember: true }}
                        onFinish={onSubmit}
                        style={{ maxWidth: 350, margin: 'auto' }}
                    >
                        <Link to="/" className="navbar-logo" style={{ textDecoration: 'none', display: 'block', marginBottom: '30px' }}>
                            <img src={require('../../assets/images/The Pickers Stop LOGO.png')} alt="The Pickers Stop" style={{ maxHeight: '60px', width: 'auto' }} />
                        </Link>

                        <Form.Item name="email" rules={[{ required: true, message: 'Please input your username!' }]}>
                            <Input
                                prefix={<UserOutlined className="site-form-item-icon" style={{ marginRight: '6px' }} />}
                                placeholder="Email"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item name="password" rules={[{ required: true, message: 'Please input your password!' }]}>
                            <Input.Password
                                size="large"
                                prefix={<LockOutlined className="site-form-item-icon" style={{ marginRight: '6px' }} />}
                                placeholder="Password"
                            />
                        </Form.Item>

                        <Form.Item>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Form.Item name="remember" valuePropName="checked" noStyle>
                                    <Checkbox>Remember me</Checkbox>
                                </Form.Item>

                                <Link className="login-form-forgot" to="/forgot-password">
                                    Forgot password
                                </Link>
                            </div>
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" size="large" htmlType="submit" style={{ width: '100%', marginBottom: '10px' }} loading={loading}>
                                Sign In
                            </Button>
                            {error && <Alert type="warning" showIcon message="Wrong username or password" style={{ marginBottom: '10px' }} />}
                            Or <Link to="/signUp">Sign up now</Link>
                        </Form.Item>

                        {/* <hr className="solid" style={{ width: '60%', color: 'red' }} />
                        <div style={{ textAlign: 'center' }}>
                            <p>Or Sign up with:</p>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <FacebookFilled style={{ fontSize: '200%', margin: '0 10px 0 10px' }} />

                                <GoogleOutlined style={{ fontSize: '200%', margin: '0 10px 0 10px' }} />
                            </div>
                        </div> */}
                    </Form>
                </div>
            </Col>
        </Row>
    );
};
